export function fixNumber(value) {
    return parseFloat(value).toFixed(2)
}
